(ns ui.fx.fetch
  (:require
   [re-frame.core :as rf]
   [lambdaisland.fetch :as fetch]
   [promesa.core :as p]
   [oops.core :as oops]))

(defn fetch-response-map?
  [possible-response-map]
  (and (map? possible-response-map)
       (-> possible-response-map
           :type
           (= ::fetch-response))))

(defn handle-response
  [on-success on-failure request resp]
  (let [{:keys [status body headers]} resp
        response-map {:type    ::fetch-response
                      :status  status
                      :body    body
                      :headers headers
                      :request request}]
    (if (<= 200 status 299)
      (rf/dispatch (conj on-success response-map))
      (rf/dispatch (conj on-failure response-map)))))

(defn handle-error
  [on-failure request err]
  (let [error-name (oops/oget err "name")
        aborted?   (= error-name "AbortError")
        error-map  {:type     ::fetch-response ;; Add type for stale response check interceptor to detect fetch response events
                    :error    err
                    :aborted? aborted?
                    :request  request}]
    (rf/dispatch (conj on-failure error-map))))

(defn fetch-fx-handler
  [request-or-requests]
  (let [requests (if (sequential? request-or-requests)
                   request-or-requests
                   [request-or-requests])]
    (doseq [req requests]
      (let [{:keys [uri method on-success on-failure]} req
            fetch-fn    (case method
                          :get    fetch/get
                          :post   fetch/post
                          :put    fetch/put
                          :delete fetch/delete
                          fetch/request)
            request-opts (dissoc req :method :uri :on-success :on-failure)]
        (-> (fetch-fn uri request-opts)
            (p/then (partial handle-response on-success on-failure req))
            (p/catch (partial handle-error on-failure req)))))))

(rf/reg-fx :fetch fetch-fx-handler)
